export function makeLineChartData(steps, color) {
    return {
        data: [0].concat(steps.map((step) => step.cumulative)),
        color,
    };
}
